import { Injectable } from '@angular/core';

import {
	ChannelGroup,
	DeviceConferenceOperationMode,
	DeviceModel
} from '@shure/shared/angular/data-access/system-api/models';
import { DeviceBehaviorPluginsService } from '@shure/shared/angular/device-behavior/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ConfirmDialogData } from '@shure/shared/angular/ui/components/dialogs/confirm';

import { DeviceUiSharedDeviceBehaviorPlugin } from './device-ui-shared-device-plugin';

@Injectable({ providedIn: 'root' })
export class DeviceUiSharedDeviceBehaviorPluginService {
	constructor(private readonly plugins: DeviceBehaviorPluginsService) {}

	public getDeviceInputChannelsSortingMap(model: DeviceModel): Map<ChannelGroup, number> | undefined {
		return (
			this.plugins
				.get<DeviceUiSharedDeviceBehaviorPlugin>(model, ['getDeviceInputChannelsSortingMap'])
				?.getDeviceInputChannelsSortingMap?.(model) ?? undefined
		);
	}

	public getDeviceOutputChannelsSortingMap(model: DeviceModel): Map<ChannelGroup, number> {
		const defaultChannelSortMap = new Map<ChannelGroup, number>([
			[ChannelGroup.DanteOutput, 1],
			[ChannelGroup.DanteLineOutput, 2],
			[ChannelGroup.AuxOutput, 3],
			[ChannelGroup.UsbOutput, 4],
			[ChannelGroup.MobileOutput, 5],
			[ChannelGroup.VirtualAudioOutput, 6],
			[ChannelGroup.PcOutput, 7],
			[ChannelGroup.Back, 8],
			[ChannelGroup.AuracastOutput, 9]
		]);

		return (
			this.plugins
				.get<DeviceUiSharedDeviceBehaviorPlugin>(model, ['getDeviceOutputChannelsSortingMap'])
				?.getDeviceOutputChannelsSortingMap?.(model) ?? defaultChannelSortMap
		);
	}

	public showNoiseReductionIntensityLevel(model: DeviceModel): boolean {
		return (
			this.plugins
				.get<DeviceUiSharedDeviceBehaviorPlugin>(model, ['showNoiseReductionIntensityLevel'])
				?.showNoiseReductionIntensityLevel?.(model) ?? false
		);
	}

	public getEqualizerBypassConfirmDialog(model: DeviceModel): ConfirmDialogData | undefined {
		return this.plugins
			.get<DeviceUiSharedDeviceBehaviorPlugin>(model, ['getEqualizerBypassConfirmDialog'])
			?.getEqualizerBypassConfirmDialog?.(model);
	}

	public showLicenseNetworkMacAddress(model: DeviceModel): boolean {
		return (
			this.plugins
				.get<DeviceUiSharedDeviceBehaviorPlugin>(model, ['showLicenseNetworkMacAddress'])
				?.showLicenseNetworkMacAddress?.(model) ?? false
		);
	}

	public showAecReferenceInfoIcon(model: DeviceModel): boolean {
		return (
			this.plugins
				.get<DeviceUiSharedDeviceBehaviorPlugin>(model, ['showAecReferenceInfoIcon'])
				?.showAecReferenceInfoIcon?.(model) ?? false
		);
	}

	public useAIAec(model: DeviceModel): boolean {
		return this.plugins.get<DeviceUiSharedDeviceBehaviorPlugin>(model, ['useAIAec'])?.useAIAec?.(model) ?? false;
	}

	public useAIDeverb(model: DeviceModel): boolean {
		return (
			this.plugins.get<DeviceUiSharedDeviceBehaviorPlugin>(model, ['useAIDeverb'])?.useAIDeverb?.(model) ?? false
		);
	}

	public isFusionEnabled(
		model: DeviceModel,
		mode: DeviceConferenceOperationMode | undefined,
		firmwareVersion: string | undefined,
		virtual: boolean
	): boolean {
		return (
			this.plugins
				.get<DeviceUiSharedDeviceBehaviorPlugin>(model, ['isFusionEnabled'])
				?.isFusionEnabled?.(model, mode, firmwareVersion, virtual) ?? false
		);
	}
}
